export default "__VITE_ASSET__2320948b__"